<h6>{{ 'customer' | translate }}: <span *ngIf="customer">{{ customer.name }}</span></h6>
<h6>{{ 'website' | translate }}: <span *ngIf="site">{{ site.url }}</span></h6>
<h6>{{ 'category' | translate }}: <span *ngIf="triggerCategory">{{ triggerCategory.name }}</span></h6>
<h6>CrmId: <span *ngIf="customer">{{ customer.crmId }}</span></h6>
<br>
<app-add-page [site]="site"></app-add-page>
<div class="col-xs-12 date-picker-score-accumulator-wrapper">
    <app-review-date-picker [datePickerMode]="DatePickerModeEnum.Date"
                            (dateSelected)="onDateSelected($event)"></app-review-date-picker>
    <app-average-score-accumulators (averageScoreAccumulatorSelected)="onAverageScoreAccumulatorSelected($event)">
    </app-average-score-accumulators>

</div>
<app-site-pages-table></app-site-pages-table>



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/site/site.component.html